<template>
<div id="modal_more_filters" class="modal modal-right fade" data-backdrop="static" role="dialog">
    <!-- <div> -->
    <div class="modal-dialog" role="document" style="width: 360px;">
        <div ref="section" class="modal-content">
            <div class="modal-header bg-dark">
                <h5 class="modal-title">{{ $t('More Filters') }}</h5>
                <button type="button" class="close" @click="closeModal()" ref="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div v-if="!isLoadData">
                <div class="modal-body p-0">
                    <!-- <div class="card card-collapsed border-0 shadow-none mb-0">
                        <div class="card-header header-elements-inline border-0 shadow-none p-0">
                            <div
                                @click="toggleSortby()"
                                aria-expanded="false"
                                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                                data-toggle="collapse"
                                data-target="#collapse-sortby">
                                    <div>{{ $t("Sort by") }}</div>
                                    <div class="header-elements">
                                        <div class="list-icons">
                                            <a
                                            class="list-icons-item"
                                            :class="{ 'rotate-180': showSortby === false }"
                                            data-action="collapse">
                                            </a>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="collapse ui-filter-list card-body px-4" id="collapse-sortby">
                            <div class="filter-option">
                                <div class="form-group">
                                    <div class="custom-control custom-radio" v-for="sortby in sortBy" :key="sortby.index">
                                        <input type="radio" class="custom-control-input" name="sortby_filter" :id="sortby.name" :value="sortby.name"  v-model="dataFilter.sortby">
                                        <label class="custom-control-label text-capitalize" :for="sortby.name">{{ $t(sortby.name) }}</label>
                                    </div>
                                </div> 
                            </div>
                            <div class="clear mt-2">
                                <a href="javascript:void(0)" 
                                @click="clearFilter('sortby')"
                                class="text-secondary">{{ $t("Clear") }}</a>
                            </div> 
                        </div>
                    </div> -->
                    <div class="card card-collapsed border-0 shadow-none mb-0">
                        <div class="card-header header-elements-inline border-0 shadow-none p-0">
                            <div
                                @click="toggleRole()"
                                aria-expanded="false"
                                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                                data-toggle="collapse"
                                data-target="#collapse-roles">
                                    <div>{{ $t("Store Type") }}</div>
                                    <div class="header-elements">
                                        <div class="list-icons">
                                            <a
                                            class="list-icons-item"
                                            :class="{ 'rotate-180': showRole === false }"
                                            data-action="collapse">
                                            </a>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="collapse ui-filter-list card-body px-4" id="collapse-roles">
                                <div class="filter-option">
                                    <div class="form-group mb-2">
                                        <div class="custom-control custom-radio" v-for="roles in rolesType" :key="roles.index">
                                            <input type="radio" class="custom-control-input" name="roles_filter" :id="roles.name" :value="roles.name"  v-model="dataFilter.roles">
                                            <label class="custom-control-label text-capitalize" :for="roles.name">{{ $t(roles.name) }}</label>
                                        </div>	 
                                        <!-- <div class="custom-control custom-radio">
                                            <input type="radio" class="custom-control-input" name="rolesRadio" id="rolesOwner">
                                            <label class="custom-control-label" for="rolesOwner">{{ $t("Owner") }}</label>
                                        </div>
                                        <div class="custom-control custom-radio">
                                            <input type="radio" class="custom-control-input" name="rolesRadio" id="rolesInvite">
                                            <label class="custom-control-label" for="rolesInvite">{{ $t("Invite") }}</label>
                                        </div> -->
                                    </div>
                                </div> 
                                <div class="clear mt-2">
                                    <a href="javascript:void(0)" 
                                    @click="clearFilter('roles')"
                                    class="text-secondary">{{ $t("Clear") }}</a>
                                </div> 
                        </div>
                    </div>
                </div>
                <div class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3">
                    <button type="button" class="btn btn-light" @click="clearFilter('all')">
                        {{ $t("Clear all filters") }}
                    </button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="doneFilter()">{{$t("Done")}}</button>
                </div>
            </div>

            <div class="modal-body" v-else>
                <placeholder-content isLoad='true'></placeholder-content>
            </div>

        </div>
    </div>
</div>
</template>

<script>

import PlaceholderContent from '@/plugins/PlaceholderContent.vue'



export default {
    name: "ModalDeleteStore",
    components: { 
        PlaceholderContent, 
    },
    data() {
        return {
            isLoadData: true,
            dataFilter: {},
            onload: false,
            showRole: false,
            showSortby: false,
            rolesType: [
                    {
                    'name': 'Owner', 
                    },
                    {
                    'name': 'Invite', 
                    }
                ],
            sortBy: [{
                    'name': 'create_date', 
                }]   
        };

    },
    methods: {       
        closeModal() {
            this.$refs.close.click();
            this.$parent.isDelete = false;
        },
        toggleSortby: function () {
        this.showSortby = !this.showSortby;
        },
        toggleRole: function () {
        this.showRole = !this.showRole;
        },
        clearFilter(key) { 
            this.dataFilter.roles = [];  
            this.$parent.countFilter = 0;
        },
        doneFilter() {
           this.$parent.countFilter = 0;
            if(this.dataFilter.roles){
                this.$parent.filterData.filter.roles = this.dataFilter.roles;
                
                if(this.dataFilter.roles.length > 0){
                    this.$parent.countFilter = 1;  
                } 
            }
            this.$parent.search(this.$parent.query.q,this.$parent.filterData);
        },

    },
    async mounted() {
        // await this.getStoreDetail();
        this.isLoadData = false;
    },
    
}
</script>
<style scoped>
.show {
  display: block !important;
}
.custom-control-input:checked~.custom-control-label::before {
    color: #455a64;
    border-color: #455a64;
    background-color: transparent;
    box-shadow: none;
}
.custom-radio .custom-control-input:checked~.custom-control-label[data-v-af527d0c]::after {
    background: #455a64;
}
</style>


// WEBPACK FOOTER //
// src/components/central/account/stores/ModalMoreFilters.vue